import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule, type MatSelectionListChange } from '@angular/material/list';

import type { ApplicationType as Application } from '@evc/platform';
import { TranslatePipe } from '@shared/services/i18n/i18n.module';

import { ApplicationsService } from '@app/services';
import type { FileItem } from '@app/types/file-item.type';

@Component({
  selector: 'available-apps',
  templateUrl: './available-apps.component.html',
  styleUrls: ['./available-apps.component.scss'],
  imports: [
    MatDialogModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    TranslatePipe,
  ],
})
export class AvailableAppsComponent implements OnInit {
  readonly #applicationsService = inject(ApplicationsService);
  readonly #dialogRef = inject<MatDialogRef<AvailableAppsComponent>>(MatDialogRef);
  readonly #data = inject<{
    file: FileItem;
    apps: Application[];
  }>(MAT_DIALOG_DATA);

  availableApplications: Application[] = [];
  selected: FileItem;

  get applications(): Application[] {
    return this.#data.apps;
  }

  ngOnInit(): void {
    const data = this.#data;

    this.selected = data.file;
    this.availableApplications = this.getAppsForFileSelected(this.selected);
  }

  areOnlyFiles(item: FileItem): boolean {
    return this.#applicationsService.areOnlyFiles([item]);
  }

  isLicenseExpired(app: Application): boolean {
    return this.#applicationsService.isLicenseExpired(app);
  }

  onOpen(item: FileItem, selected: MatSelectionListChange): void {
    const app: Application = selected.options[0].value;

    if (!this.isLicenseExpired(app) && this.areOnlyFiles(item)) {
      this.#dialogRef.close({ file: item, app });
    }
  }

  getAppsForFileSelected(item: FileItem): Application[] {
    return this.#applicationsService.getAppsForFileSelected([item], this.applications);
  }

  openLink(link: string): void {
    this.#applicationsService.openLink(link);
  }

  trackById(idx: number, app: Application): string {
    return `${app.code}-${idx}`;
  }
}
